import { gql } from '../../__gql__/gql';

export const CURRENCIES = gql(`
  query Currencies {
    currencies
  }
`);
